import { DataGridPro } from '@mui/x-data-grid-pro';
import { useBoundStore } from 'useStore';
import {
	columns,
	getDetailPanelHeight,
	getRowHeight,
	getRowId,
	gridStyles,
	rowsPerPageOptions,
	slots,
} from './utils';

export default function HistoryTable({ data, count, loading }) {
	const paginationModel = useBoundStore((state) => state.fhPaginationModel);
	const setPaginationModel = useBoundStore(
		(state) => state.setFhPaginationModel
	);

	return (
		<DataGridPro
			loading={loading}
			rows={data}
			rowCount={count}
			getRowId={getRowId}
			columns={columns}
			pageSize={25}
			getDetailPanelHeight={getDetailPanelHeight}
			getRowHeight={getRowHeight}
			disableColumnMenu
			pagination
			paginationMode="server"
			paginationModel={paginationModel}
			onPaginationModelChange={setPaginationModel}
			pageSizeOptions={rowsPerPageOptions}
			disableRowSelectionOnClick
			disableColumnReorder
			slots={slots}
			sx={gridStyles}
		/>
	);
}
